<template>
  <div class="container">
    <el-row class="common-box" v-loading="float1Loading">
      <div class="common-box-title common-box-Htitle clearfix">
        <h2 class="floatl">行业品类</h2>
        <el-button type="primary" round size="mini" :disabled="auths.indexOf(2) < 0"
                   @click="showCategoryDialog('行业品类', 1)">编辑
        </el-button>
      </div>
      <div class="common-box-body">
        <div class="label-wrap clearfix" v-for="(item, index) in signList" :key="index">
          <div class="floatl label-name">
            <img src="../../common/images/icon-label.png" alt=""> {{item.label}}
          </div>
          <div class="label-list clearfix" ref="slideWrap">
            <div :class="{'toggle-btn': item.children ? (item.children.length > treeCol.length) : false }"
                 @click="toggleSlide">
            </div>
            <div>
              <div class="label-tree floatl" v-for="(item2,index2) in treeCol">
                <el-tree v-for="(i, ind) in item.children" v-if="ind % treeCol.length === item2" :key="ind" :data="[i]"
                         :props="defaultProps" @node-click="overToggle('body')"
                         @node-expand="overToggle('button')"></el-tree>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-row>

    <el-row class="common-box" v-loading="float2Loading">
      <div class="common-box-title common-box-Htitle clearfix">
        <h2 class="floatl">岗位类型</h2>
        <el-button type="primary" round size="mini" :disabled="auths.indexOf(2) < 0"
                   @click="showCategoryDialog('岗位类型', 2)">编辑
        </el-button>
      </div>
      <div class="common-box-body">
        <div class="post-item" v-for="(item, index) in postList" :key="index">
          <div class="tag long" :class="{'long': index % 2 == 0, 'short': index % 2 == 1}">{{item.label.slice(0, 1)}}
          </div>
          {{item.label}}
        </div>
      </div>
    </el-row>

    <el-row class="common-box" v-loading="float3Loading">
      <div class="common-box-title common-box-Htitle clearfix">
        <h2 class="floatl">自我标签</h2>
        <el-button type="primary" round size="mini" :disabled="auths.indexOf(2) < 0" @click="openAddDialog">编辑
        </el-button>
      </div>
      <div class="common-box-body cleafix">
        <div class="self-label floatl" v-for="item in selfLabel" :key="item.id">{{item.signName}}</div>
      </div>
    </el-row>

    <!-- 二级-修改行业品类和岗位类型的弹框 -->
    <el-dialog class="cardDialog dialog" :title="categoryDialogTitle" :visible.sync="categoryDialog" width="780px"
               center>
      <div class="dialog-body" v-loading="categoryDialogLoading">
        <div style="text-align: right; margin-bottom: 10px;">
          <el-button type="primary" round size="small"
                     @click="openAddTreeLabelDialog(1, categoryDialogSignType, null)">
            + 添加{{categoryDialogTitle}}
          </el-button>
        </div>
        <div style="max-height: 600px;overflow-y: scroll">
          <el-tree class="tree-area" :indent="30" :data="categoryDialogList" :props="defaultProps"
                   :expand-on-click-node="false" node-key="value" :default-expanded-keys="expandedIds">
            <div slot-scope="{ node, data }">
              <div class="clearfix" style="width: 100%;" v-if="categoryDialogSignType != 2">
                <span class="floatl title">
                  <span class="delete-btn" @click="remove(node, data, categoryDialogSignType)"></span>
                  <span>{{node.label}}</span>
                </span>
                <div class="floatr" style="line-height: 42px;margin-left: 10px">
                  <el-button size="mini" class="edit-btn" @click="editLabelName(node, data)">
                    <div class="editBtnIcon">修改标签</div>
                  </el-button>
                  <el-button size="mini" class="add-btn"
                             @click="openAddTreeLabelDialog(node.data.signLevel + 1,categoryDialogSignType,node.data.value)">
                    <div class="addBtnIcon">添加下级分类</div>
                  </el-button>
                </div>
              </div>

              <div class="clearfix" style="width: 100%;" v-else>
                <span v-if="node.label == '不限'">{{node.label}}</span>
                <div v-else>
                  <span class="floatl title">
                    <span class="delete-btn" @click="remove(node,data,categoryDialogSignType)"></span>
                    <span>{{node.label}}</span>
                  </span>
                  <div class="floatr" style="line-height: 42px;margin-left: 10px">
                    <el-button size="mini" class="edit-btn" @click="editLabelName(node, data)">
                      <div class="editBtnIcon">修改标签</div>
                    </el-button>
                  </div>
                </div>
              </div>
            </div>
          </el-tree>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
          <el-button type="text" size="small" @click="categoryDialog = false">取 消</el-button>
          <el-button type="primary" size="small" @click="categoryDialog = false">确 定</el-button>
        </span>
    </el-dialog>

    <!-- 添加行业品类岗位类型的三级对话框 -->
    <el-dialog class="cardDialog dialog" :title="'添加' + categoryDialogTitle" :visible.sync="addTreeLabelDialog"
               width="400px" center>
      <div v-loading="addTreeLabelDialogLoading">
        <div class="dialog-body">
          <el-form inline class="formInline" size="mini">
            <el-input v-model="addTreeLabelDialogInput" size="mini" style="width:220px; margin-right: 10px;"
                      :placeholder="'请输入新增' + categoryDialogTitle + '标签的名称...'"
                      @keyup.enter.native="addNewLabel(addTreeLabelDialogInput, addTreeLabelDialogSignLevel, addTreeLabelDialogSignType, addTreeLabelDialogPid, addTreeLabelDialogList)"></el-input>
            <el-button size="mini" type="primary"
                       @click="addNewLabel(addTreeLabelDialogInput, addTreeLabelDialogSignLevel, addTreeLabelDialogSignType, addTreeLabelDialogPid, addTreeLabelDialogList)">
              确认添加
            </el-button>
          </el-form>
          <div class="tag-list">
            <div class="tag-item" v-for="item in addTreeLabelDialogList" :key="item.id">{{item.signName}}
              <span class="remove-btn" @click="deleteLabel(item)"></span>
            </div>
          </div>
        </div>
        <div class="el-dialog__footer" style="text-align: center;padding: 10px 0">
          <span slot="footer" class="dialog-footer">
            <el-button type="text" size="small" @click="addTreeLabelDialog = false">取 消</el-button>
            <el-button class="dialog-btn" size="small" @click="saveUpdate(addTreeLabelDialogSignType)">确 定</el-button>
          </span>
        </div>
      </div>
    </el-dialog>

    <!-- 添加自我标签对话框 -->
    <el-dialog class="cardDialog dialog" title="自我标签" :visible.sync="addDialog" width="780px" center @close="getData">
      <div class="dialog-body" v-loading="addDialogLoading">
        <el-form inline class="formInline" size="mini">
          <el-input v-model="addDialogInput" size="mini" style="width:220px; margin-right: 10px;"
                    placeholder="请输入新增标签的名称..."
                    @keyup.enter.native="addNewLabel(addDialogInput, null, 3, null, addDialogList)"></el-input>
          <el-button size="mini" type="primary" @click="addNewLabel(addDialogInput, null, 3, null, addDialogList)">
            确认添加
          </el-button>
        </el-form>
        <div class="tag-list">
          <div class="tag-item" v-for="item in addDialogList" :key="item.id">{{item.signName}}
            <span class="remove-btn" @click="deleteSelfLabel(item)"></span>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="text" size="small" @click="addDialog = false">取 消</el-button>
        <el-button class="dialog-btn" size="small" style="background-color: #8299dc"
                   @click="saveUpdate(3)" :disabled="addDialogLoading">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 修改行业品类标签对话框 -->
    <el-dialog class="cardDialog dialog" :title="categoryDialogTitle" :visible.sync="editLabelNameDialog" width="400px"
               center>
      <div class="dialog-body" style="margin-top: 15px">
        <el-form inline class="formInline" size="mini">
          <el-form-item label="标签名称：">
            <el-input v-model="editForm.jobTypeName" size="mini" style="width:220px;"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="text" size="small" @click="editLabelNameDialog = false">取 消</el-button>
        <el-button class="dialog-btn" size="small" @click="saveEditLabel">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  //180717韩金辰全面整理优化
  import utils from '../../common/js/util'

  export default {
    data() {
      return {
        float1Loading: false,//行业标签，岗位类型，自我标签，数据加载的loading
        float2Loading: false,
        float3Loading: false,
        addDialogLoading : false,//自我标签的弹窗loading
        signList: [],//主页面行业标签，岗位类型，自我标签，数据存放
        postList: [],
        selfLabel: [],
        screenWidth: document.body.clientWidth,//视窗宽度，计算列数
        //树形结构的默认配置
        defaultProps: {
          children: "children",
          label: "label"
        },

        categoryDialog: false,//点击主页行业标签，岗位类型树的编辑二级弹窗
        categoryDialogTitle: "",
        categoryDialogSignType: "",//弹框标志位，1行业品类，2岗位类型
        categoryDialogList: [],//弹框中的树形数据

        addTreeLabelDialog: false,//行业品类、岗位类型三级弹窗
        addTreeLabelDialogLoading: false,
        addTreeLabelDialogList: [],
        addTreeLabelDialogInput: "",
        addTreeLabelDialogSignLevel: "",
        addTreeLabelDialogSignType: "",
        addTreeLabelDialogPid: "",

        addDialog: false,//自我标签二级弹窗
        addDialogList: [],
        addDialogInput: "",

        addList: [],//需要添加的数据中转存储在这里，其实不用这个，现在既然用了就最好别动他否则大改
        auths: [],// 页面内权限
        expandedIds: [],

        editLabelNameDialog: false,// 修改标签名
        editForm: {
          jobTypeName: null,
          data: null,
          node: null,
          signType: null
        }
      };
    },
    mounted() {
      this.getData();
      this.getAuth();
      let _this = this;
      window.onresize = function temp() {
        _this.screenWidth = document.documentElement.clientWidth;
      };
    },
    computed: {
      //样式相关,根据视窗宽度计算列数
      treeCol() {
        let width = this.screenWidth
        let cols = 0
        if (width < 1440) {
          cols = 3
        } else if (width < 1640) {
          cols = 4
        } else if (width < 1890) {
          cols = 5
        } else {
          cols = 6
        }
        let data = []
        for (let i = 0; i < cols; i++) {
          data.push(i)
        }
        return data
      },
      categoryDialogLoading:{
        get(){
          let flag = false
          if (this.categoryDialog) {
            flag = this.categoryDialogSignType == 1 ? this.float1Loading : this.float2Loading
          }
          return flag
        },
        set(newVal){}
      }
    },
    methods: {
      /*
      工具类
      */
      //工具类-树形结构解析相关
      pushChildren(data, arr) {
        arr.forEach(item => {
          if (item.value == data.pid) {
            item.children.push({
              value: data.id,
              label: data.signName,
              signLevel: data.signLevel,
              pid: data.pid,
              children: []
            });
          } else {
            this.pushChildren(data, item.children);
          }
        });
      },
      //工具类-树形结构解析相关
      clearEmptyChildren(arr) {
        arr.forEach(item => {
          if (item.children.length === 0) {
            delete item.children;
          } else {
            this.clearEmptyChildren(item.children);
          }
        });
      },
      /*
      主页面相关--一级
      */
      //获取数据-行业品类、岗位类型、自我标签
      //有时候需要更新数据后重新打开弹框，所以传这个参数
      getData(openDialog) {
        // 行业品类
        this.float1Loading = true
        this.$http({
          method: "GET",
          url: "/rest/projectSign/getSignLst",
          params: {
            signType: 1
          }
        }).then(res => {
          this.float1Loading = false
          let data = res.data;
          this.signList = [];
          data.map(item => {
            item.map(item2 => {
              if (item2.signLevel == 1) {
                this.signList.push({
                  value: item2.id,
                  label: item2.signName,
                  signLevel: item2.signLevel,
                  pid: item2.pid,
                  children: []
                });
              } else if (item2.signLevel > 1) {
                this.pushChildren(item2, this.signList);
              }
            })
          })
          this.clearEmptyChildren(this.signList)
          if (openDialog == '行业品类') {
            this.showCategoryDialog(openDialog, 1);
          }
        }).catch(err => {
          this.float1Loading = false
          utils.myNotify(this, 'error', err.response, '查询失败，请稍后重试')
        })

        // 岗位类型
        this.float2Loading = true
        this.$http({
          method: "GET",
          url: "/rest/projectSign/getSignLst",
          params: {
            signType: 2
          }
        }).then(res => {
          this.float2Loading = false
          let data = res.data;
          this.postList = [];
          data.map(item => {
            item.map(item2 => {
              if (item2.signLevel == 1) {
                this.postList.push({
                  value: item2.id,
                  label: item2.signName,
                  signLevel: item2.signLevel,
                  pid: item2.pid,
                  children: []
                });
              } else if (item2.signLevel > 1) {
                this.pushChildren(item2, this.postList);
              }
            })
          })
          this.clearEmptyChildren(this.postList)
          if (openDialog == '岗位类型') {
            this.showCategoryDialog(openDialog, 2);
          }
        }).catch(err => {
          this.float2Loading = false
          utils.myNotify(this, 'error', err.response, '查询失败，请稍后重试')
        })

        // 自我标签
        this.float3Loading = true
        if(openDialog == '自我标签'){this.addDialogLoading = true}
        this.$http({
          method: "GET",
          url: "/rest/sign/search",
          params: {
            signType: 3,
            signLevel: null,
            pid: null
          }
        }).then(res => {
          this.float3Loading = false
          this.addDialogLoading = false
          this.selfLabel = res.data
        }).catch(err => {
          this.addDialogLoading = false
          this.float3Loading = false
          utils.myNotify(this, 'error', err.response, '查询失败，请稍后重试')
        })
      },
      //获取权限
      getAuth() {
        this.$http({
          method: "GET",
          url: "/rest/sysUser/getSysUserWebAuth",
          params: {
            webId: 8,
            sysUserId: sessionStorage.getItem("sysUserId")
          }
        }).then(res => {
          res.data.map(item => {
            this.auths.push(item.auth)
          })
        }).catch(err => {
          utils.myNotify(this, 'error', err.response, '查询失败，请稍后重试')
        })
      },
      //收起展开一级选项栏
      toggleSlide(event) {
        let target = event.target;
        let parentNode = target.parentNode;
        if (parentNode.offsetHeight > 40) {
          target.className = "toggle-btn";
          parentNode.style.height = 40 + "px";
        } else {
          target.className = "toggle-btn up";
          parentNode.style.height = "auto";
        }
      },
      // 主页面的树，右上角点击编辑（行业和岗位标签）
      showCategoryDialog(dialogTitle, signType) {
        this.categoryDialog = true;
        this.categoryDialogList = signType == 1 ? this.signList : this.postList;//不是1就是2,1行业品类2岗位类型
        this.categoryDialogTitle = dialogTitle;
        this.categoryDialogSignType = signType;
      },
      // 主页面的树，右上角点击编辑（自我标签）
      openAddDialog() {
        this.addDialogList = this.selfLabel.slice(0)
        this.addDialog = true;
        this.addList = [];
      },
      //收起展开一级选项栏,点击tree标签上的箭头的时候
      overToggle(from) {
        // 跟this.toggleSlide类似，但事件对象不同(这里必须从全局event里拿)，逻辑也不大相同
        let target = event.target;
        //.......额
        let parentNode = target.parentNode.parentNode.parentNode.parentNode.parentNode;
        if (from == 'button') parentNode = parentNode.parentNode
        let toggle_btn = parentNode.getElementsByClassName('toggle-btn')
        setTimeout(() => {
          if (parentNode.offsetHeight <= 40) {
            if (toggle_btn.length > 0) {
              toggle_btn[0].className = "toggle-btn up"
            }
            parentNode.style.height = "auto";
          }
        }, 50)
      },
      /*
      编辑弹框相关--二级
      */
      //编辑弹窗中的删除单行功能
      remove(node, data, signType) {
        let pid = data.pid
        let signId = data.value;
        this.expandedIds = []
        this.$confirm("此操作将永久删除该标签及该标签下所有子标签, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          this.categoryDialogSignType == 1 ? this.float1Loading = true : this.float2Loading = true
          this.$http({
            method: "POST",
            url: "/rest/salesman/deleteSalesmanSign",
            params: {
              signId: signId
            }
          }).then(() => {
            // 编辑项目标签(含解绑)
            this.$http({
              method: "POST",
              url: '/rest/projectSign/deleteProjectSign',
              params: {
                signId: signId
              }
            }).then(res => {
              utils.myNotify(this, 'success', res, '操作成功')
              // 删除标签时，相应的促销员标签也要删除
              this.$http({
                method: "POST",
                url: "/rest/sign/delete",
                data: [
                  {
                    id: data.value,
                    signName: data.label,
                    signType: signType,
                    pid: null,
                    signLevel: data.signLevel,
                  }]
              }).catch(err => {
                utils.myNotify(this, 'error', err.response, '操作失败，请稍后重试')
              }).then(() => {
                this.getData(signType == 1 ? '行业品类' : '岗位类型');
                this.expandedIds.push(pid)
              })
            }).catch(err => {
              utils.myNotify(this, 'error', err.response, '操作失败，请稍后重试')
            })
          });
        });
      },
      //编辑弹窗中的修改标签按钮
      editLabelName(node, data) {
        this.editLabelNameDialog = true
        this.editForm.jobTypeName = data.label
        this.categoryDialogTitle == '行业品类' ? this.editForm.signType = 1 : this.editForm.signType = 2
        this.editForm.data = data
        this.editForm.node = data.node
      },
      //主页树-右上角编辑-弹框中右上角添加
      openAddTreeLabelDialog(signLevel, signType, pid) {
        console.log(pid);
        this.addTreeLabelDialog = true;
        this.addTreeLabelDialogList = [];
        this.addTreeLabelDialogSignLevel = signLevel;
        this.addTreeLabelDialogSignType = signType;
        this.addTreeLabelDialogPid = pid;

        this.addList = [];
      },
      //自我标签二级弹框，点击'列表中删除按钮'
      deleteSelfLabel(data) {
        // 有id要弹窗确认，成功删除后再更新列表
        let signId = data.id;
        if (signId) {
          this.$confirm("此操作将永久删除该标签, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }).then(() => {
            this.addDialogLoading = true
            this.$http({
              method: "POST",
              url: "/rest/salesman/deleteSalesmanSign",
              params: {
                signId: signId
              }
            }).then(() => {
              // 删除标签时，相应的促销员标签也要删除
              this.$http({
                method: "POST",
                url: "/rest/sign/delete",
                data: [{
                  id: data.id,
                  signName: data.signName,
                  signType: 3,
                  pid: null,
                  signLevel: null
                }]
              }).then(res => {
                this.addDialogLoading = false
                utils.myNotify(this, 'success', res, '操作成功')
                this.addDialogList.forEach((item, index, arr) => {
                  if (item.signName === data.signName && item.id === data.id) {
                    arr.splice(index, 1);
                  }
                });
                this.addList.forEach((item, index, arr) => {
                  if (item.signName === data.signName && item.id === data.id) {
                    arr.splice(index, 1);
                  }
                })
                this.getData('自我标签')
              }).catch(err => {
                this.addDialogLoading = false
                utils.myNotify(this, 'error', err.response, '查询失败，请稍后重试')
              })
            })
          })
        } else {
          this.addDialogList.forEach((item, index, arr) => {
            if (item.signName === data.signName && item.id === data.id) {
              arr.splice(index, 1);
            }
          });
          this.addList.forEach((item, index, arr) => {
            if (item.signName === data.signName && item.id === data.id) {
              arr.splice(index, 1);
            }
          });
        }
      },
      /*
      编辑弹框相关--三级
      */
      //编辑弹窗-修改标签-三级弹窗点击确认
      saveEditLabel() {
        this.$confirm("此操作将修改该标签名称, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          let editLabel = [{
            id: this.editForm.data.value,
            signName: this.editForm.jobTypeName,
            signType: this.editForm.signType,
          }]
          this.$http({
            method: "POST",
            url: "/rest/sign/saveUpdate",
            data: editLabel
          }).then(res => {
            this.expandedIds = []
            utils.myNotify(this, 'success', res, '操作成功')
            this.editLabelNameDialog = false
            setTimeout(() => {
              if (this.editForm.signType == 1) {
                this.showCategoryDialog("行业品类", 1);
              } else if (this.editForm.signType == 2) {
                this.showCategoryDialog("岗位类型", 2);
              }
            }, 500);
            this.getData();
            this.expandedIds.push(this.editForm.data.pid)
          }).catch(err => {
            if (err.response.data.status == 400) {
              utils.myNotify(this, 'error', '该标签已存在！')
            } else {
              utils.myNotify(this, 'error', err.response, '操作失败')
            }
          })
        });
      },
      //自我标签二级弹框-或者行业和岗位标签三级弹窗中，点击'确认添加'的通用方法
      addNewLabel(signName, signLevel, signType, pid, arr) {
        if (signName.replace(/\s+/g, '') == "") {
          utils.myNotify(this, 'warning', "您输入的内容为空")
        } else {
          for (var i = 0; i < arr.length; i++) {
            if (arr[i].signName === signName) {
              utils.myNotify(this, 'warning', "您输入的标签内容重复，请重新输入")
              return false;
            }
          }
          this.addList.push({
            signName: signName,
            signType: signType,
            pid: pid,
            signLevel: signLevel
          });
          arr.push({
            signName: signName,
            signType: signType,
            pid: pid,
            signLevel: signLevel
          });
          this.addDialogInput = "";
          this.addTreeLabelDialogInput = "";
        }
      },
      //行业和岗位标签三级弹窗中，点击'列表中删除按钮'
      deleteLabel(data) {
        this.addTreeLabelDialogList.forEach((item, index, arr) => {
          if (item.signName === data.signName && item.id === data.id) {
            arr.splice(index, 1);
          }
        });
        this.addList.forEach((item, index, arr) => {
          if (item.signName === data.signName && item.id === data.id) {
            arr.splice(index, 1);
          }
        });
      },
      //添加标签最终点击确认时的通用方法
      saveUpdate(signType) {
        this.expandedIds = []
        if (this.addList.length === 0) {
          this.addDialog = false;
          this.addTreeLabelDialog = false;
          return false;
        }
        signType == 3 ? this.addDialogLoading = true :this.addTreeLabelDialogLoading = true;
        this.$http({
          method: "POST",
          url: "/rest/sign/saveUpdate",
          data: this.addList
        }).then(res => {
          utils.myNotify(this, 'success', res, '操作成功')
          this.getData(signType == 1 ? '行业品类' : (signType == 2 ? '岗位类型': null))
          this.expandedIds.push(this.addList[0].pid)
          this.addDialog = false
          signType == 3 ? this.addDialogLoading = false :this.addTreeLabelDialogLoading = false;
          this.addTreeLabelDialog = false
          // this.categoryDialog = false
        }).catch(err => {
          utils.myNotify(this, 'error', err.response, '查询失败，请稍后重试')
          signType == 3 ? this.addDialogLoading = false :this.addTreeLabelDialogLoading = false;
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .label-wrap {
    width: 100%;
    background-color: #f8f8f8;
    border-radius: 5px;
    padding: 10px 10px 0;
    box-sizing: border-box;
    margin-bottom: 10px;
    .label-name {
      width: 165px;
      font-size: 14px;
      color: #333;
      line-height: 30px;
      padding-left: 10px;
      box-sizing: border-box;
      background: url(../../common/images/icon-arrow-right.png) right center no-repeat;
    }
    .label-list {
      margin-left: 180px;
      padding-right: 35px;
      position: relative;
      height: 40px;
      min-height: 40px;
      overflow: hidden;
      &::before {
        content: "";
        display: block;
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 10px;
        background-color: #f8f8f8;
        z-index: 99;
      }
      .toggle-btn {
        position: absolute;
        width: 16px;
        height: 16px;
        top: 6px;
        right: 0;
        background-image: url(../../common/images/11zhankai.png);
        background-repeat: no-repeat;
        background-position: top left;
        z-index: 99;
        &.up {
          background-image: url(../../common/images/12shouqi.png);
        }
      }
      .label-tree {
        width: 220px;
        display: inline-block;
        margin-right: 20px;
        /*margin-bottom: 10px;*/
        border-radius: 5px;
        overflow: hidden;
        vertical-align: top;
      }
    }
  }

  .post-item {
    height: 40px;
    line-height: 40px;
    display: inline-block;
    font-size: 14px;
    color: #333;
    margin-right: 40px;
    .tag {
      display: inline-block;
      width: 40px;
      height: 40px;
      border-radius: 20px;
      text-align: center;
      color: #fff;
      margin-right: 10px;
      &.long {
        background-color: #8299dc;
      }
      &.short {
        background-color: #81bc82;
      }
    }
  }

  .self-label {
    font-size: 12px;
    color: #8299dc;
    background-color: #f4f4f4;
    line-height: 30px;
    padding: 0 26px;
    margin-right: 20px;
    margin-bottom: 20px;
    border-radius: 5px;
  }

  .dialog-body {
    .tag-list {
      margin-top: 10px;
      margin-bottom: 60px;
      .tag-item {
        display: inline-block;
        line-height: 30px;
        background-color: #f4f4f4;
        padding-left: 20px;
        padding-right: 10px;
        border-radius: 5px;
        margin-right: 10px;
        margin-bottom: 10px;
        color: #8299dc;
        .remove-btn {
          display: inline-block;
          width: 20px;
          height: 20px;
          vertical-align: middle;
          margin-left: 20px;
          background: url(../../common/images/icon-delete.png) no-repeat center;
        }
      }
    }
  }
</style>




// WEBPACK FOOTER //
// src/views/labelSystem/labelManagement.vue